import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants'
import {AdminUserLoginInfo, RelatedAssocUserInfo} from './AdminUserLoginInfo'
import {NatPostResidentLogout} from './NatPostResidentLogout'
import {ApiResponse} from '../../../../network/response/ApiResponse'

export default class AdminAuthRepository {
    http: Http

    constructor(http: Http) {
        this.http = http
    }

    async login(username: string, password: string): Promise<AdminUserLoginInfo> {
        return await this.http.post('/admin/login', {username, password}, ContentType.FORM)
    }

    async assocLogin(username: string, password: string): Promise<RelatedAssocUserInfo> {
        return await this.http.post('/admin/assoc/login', {
            username: encodeURIComponent(username),
            password: encodeURIComponent(password),
        }, ContentType.FORM)
    }

    async selectAssocUser(condominiumCd: string): Promise<ApiResponse<AdminUserLoginInfo>> {
        return await this.http.post('/admin/assoc/select-user', {condominiumCd}, ContentType.JSON)
    }

    // ログアウト（管理）
    async logout(): Promise<NatPostResidentLogout> {
        return await this.http.post(`/admin/logout`, {}, ContentType.JSON,
        )
    }
}
